import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicSectionMutationKeys } from '../../../keys'
import { deleteDynamicSection } from '../../services'

interface UseMutationDeleteDynamicSectionProps {
	id: string
}

export default function useMutationDeleteDynamicSection(
	props?: UseBaseMutationOptions<void, UseMutationDeleteDynamicSectionProps>,
) {
	return useMutation({
		mutationKey: [DynamicSectionMutationKeys.DeleteDynamicSection],
		mutationFn: ({ id }) => deleteDynamicSection(id),
		...props,
	})
}
